<!-- 金融服务 -->
<template>
<div class="site-content">
  <div class="site-content-banner">
    <img src="./../../assets/kjfw_banner_01.png"/>
  </div>
  <div class="site-content-page width-per-100">
    <div class="content-row">
      <div class="content-col">
         <col-info-list :showTitle="true" :showMore="false" :infoBlock="infoBlock1" title="金融服务" label="SERVICE ORGANIZATION" col="2" count="4" :infoPage="infoPage1" v-on:queryPage="jrfw_Req"/>
      </div>
    </div>
    <div class="content-row">
      <div class="content-col">
         <col-info-list :showTitle="true" :showMore="false" :infoBlock="infoBlock2" title="服务机构" label="SERVICE ORGANIZATION" col="3" count="3" :infoPage="infoPage2" v-on:queryPage="fwjg_Req"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ColInfoList from '../block/ColInfoList'
import JrfwInfo1 from '../module/JrfwInfo1'
import JrfwInfo2 from '../module/JrfwInfo2'
export default {
  name: 'Jrfw01',
  components: {
    'col-info-list': ColInfoList,
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App---template',
      infoBlock1:JrfwInfo1,
      infoBlock2:JrfwInfo2,
      infoPage1:{list:[],total:0},
      infoPage2:{list:[],total:0},
    }
  },
  methods:{
    //金融服务
    jrfw_Req(params){
          let that=this;
          params.p=1;
          //params.type="金融服务";
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.orgServiceLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage1=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
    //服务机构
    fwjg_Req(params){
          let that=this;
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.orgEnterpriseLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage2=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.width-per-100{
  width:100%;
}
.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Jrfw01.vue